@if (allSimilar().length) {
  <div class="similar-tools border-themed border-t pt-8" data-testid="similar-tools-section">
    <div class="mb-5" data-testid="similar-tools-header">
      <p class="text-button-red text-[10px] font-semibold uppercase tracking-[0.35em]">
        {{ 'hrTool.similar' | transloco }}
      </p>
      <h2 class="text-lg font-bold tracking-tight">
        {{ 'hrTool.similarTitle' | transloco }}
      </h2>
    </div>

    <p-carousel
      data-testid="similar-tools-carousel"
      [value]="allSimilar()"
      [numVisible]="viewport().numVisible"
      [numScroll]="viewport().numScroll"
      [circular]="isCircular()"
      [autoplayInterval]="0"
    >
      <ng-template #item let-tool>
        @if (!tool.isPlaceholder) {
          <div class="h-full px-2" data-testid="similar-tool-item">
            <button
              type="button"
              class="hr-similar-card"
              (click)="navigate(tool)"
              [attr.data-testid]="'similar-tool-' + tool.id"
            >
              <div class="hr-similar-card__logo">
                @if (tool.coverImage) {
                  <img
                    [src]="tool.coverImage"
                    [alt]="tool.translatedName"
                    class="max-h-full max-w-full object-contain"
                    (error)="hideBrokenImage($event)"
                  />
                }
              </div>
              <p class="hr-similar-card__name">{{ tool.translatedName }}</p>
            </button>
          </div>
        } @else {
          <div
            class="pointer-events-none h-full px-2 opacity-0"
            data-testid="similar-tool-placeholder"
          >
            <div class="h-full w-full"></div>
          </div>
        }
      </ng-template>
    </p-carousel>
  </div>
}
